import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { WiFiFrequencyEnum, WiFiFrequencyEnumConverter } from "../enum/wifi-frequency.enum";

@JsonObject("ChannelItem")
export class ChannelItem {
    @JsonProperty("channelN", Number, true)
    channelN: number = 0;
}

@JsonConverter
export class ChannelItemArrayConverter implements JsonCustomConvert<Array<ChannelItem>> {
    serialize() { }
    deserialize(data: any): Array<ChannelItem> {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeArray(data ?? [], ChannelItem);
    }
}

@JsonConverter
export class ChannelsConverter implements JsonCustomConvert<Channels> {
    serialize() { }
    deserialize(data: any): Channels {
        const channel = new Channels();
        channel.channelId = data?.channelId ?? "";
        channel.frequency = new WiFiFrequencyEnumConverter().deserialize(data?.frequency);
        channel.channel = new ChannelItemArrayConverter().deserialize(data?.channel ?? []);
        return channel;
    }
}

@JsonConverter
export class ChannelsArrayConverter implements JsonCustomConvert<Array<Channels>> {
    serialize() { }
    deserialize(data: any): Array<Channels> {
        const converter = new ChannelsConverter();
        return (data ?? []).map((item: any) => converter.deserialize(item));
    }
}

@JsonConverter
export class ChannelsListConverter implements JsonCustomConvert<ChannelsCountList> {
    serialize() { }
    deserialize(data: any): ChannelsCountList {
        const list = new ChannelsCountList();
        list.count = Number(data?.count ?? 0);
        list.items = new ChannelsArrayConverter().deserialize(data?.items ?? data?.data ?? []);
        return list;
    }
}

@JsonObject("Channels")
export class Channels {
    @JsonProperty("channelId", String, true)
    channelId: string = "";
    @JsonProperty("frequency", WiFiFrequencyEnumConverter, true)
    frequency: WiFiFrequencyEnum = WiFiFrequencyEnum.FREQ_2_4_GHZ;
    @JsonProperty("channel", ChannelItemArrayConverter, true)
    channel: Array<ChannelItem> = [];
}

@JsonObject("ChannelsCountList")
export class ChannelsCountList {
    @JsonProperty("count", Number, true)
    count: number = 0;
    items: Array<Channels> = [];
}

@JsonObject("ChannelsData")
export class ChannelsData extends BaseResponse {
    @JsonProperty("data", ChannelsConverter, true)
    data: Channels = new Channels();
}

@JsonObject("ChannelsDataArray")
export class ChannelsDataArray extends BaseResponse {
    @JsonProperty("data", ChannelsListConverter, true)
    data: ChannelsCountList = new ChannelsCountList();
}
